import React, { FunctionComponent } from 'react'
import Equipment from '../../entities/Equipment'
import EquipmentTableRow from './EquipmentTableRow'
import { Table } from '../table'
import Visualization from '../../entities/Visualization'

export type EquipmentViewVariant = 'standard' | 'conflict' | 'model_conflict'

export type Props = {
    equipments: Equipment[]
    viewVariant: EquipmentViewVariant
    selectEquipment: Function
    deselectEquipment: Function
    openInfoModal: Function
    priceColWidth?: string
    visualization: Visualization
    language: string
}

const EquipmentTable: FunctionComponent<Props> = (props) => {
    const {
        equipments,
        viewVariant,
        selectEquipment,
        deselectEquipment,
        openInfoModal,
        priceColWidth,
        visualization,
        language,
    } = props

    if (equipments.length === 0) {
        return null
    }

    const tableRows = equipments.map((equipment) => (
        <EquipmentTableRow
            key={`${equipment.id}-${viewVariant}`}
            equipment={equipment}
            viewVariant={viewVariant}
            selectEquipment={selectEquipment}
            deselectEquipment={deselectEquipment}
            openInfoModal={openInfoModal}
            priceColWidth={priceColWidth}
            visualization={visualization}
            language={language}
        />
    ))

    return (
        <Table>
            <tbody>
                {tableRows}
            </tbody>
        </Table>
    )
}

export default EquipmentTable
